export const SET_USER         = 'AUTH/SET_USER';
export const SET_USER_SCOPES  = 'AUTH/SET_USER_SCOPES';
export const SET_TOKEN        = 'AUTH/SET_TOKEN';
export const DELETE_TOKEN     = 'AUTH/DELETE_TOKEN';
export const SET_APP_TOKEN    = 'AUTH/SET_APP_TOKEN';